// react core
import React from 'react';

export default function IsCommunityCodeValidator({ code })
{
    if (code.length < 1) return (<></>);
    if (code.length < 5) return (<div className='input-warning'>Invalid code format</div>)
    return (<br/>)
}
